import { AnalyticsEvent } from "../models";

export class CancelOrderConfirmationVisibleEvent implements AnalyticsEvent {
  name = 'CancelOrderConfirmationVisibleEvent';
  cancellationReason: string;

  constructor(cancellationReason: string = "") {
    this.cancellationReason = cancellationReason;
  }
}